import { render, staticRenderFns } from "./layoutFee.vue?vue&type=template&id=53012d16"
import script from "./layoutFee.vue?vue&type=script&lang=js"
export * from "./layoutFee.vue?vue&type=script&lang=js"
import style0 from "./layoutFee.vue?vue&type=style&index=0&id=53012d16&prod&lang=css"
import style1 from "./layoutFee.vue?vue&type=style&index=1&id=53012d16&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports